// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"bv","itemsContainer":"cv"};